// CUSTOMIZATION:
// - Cambiato il titolo della sezione Contatti

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import {
  RichTextArticle,
  OfficeCard,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  contatti_servizio_view: {
    id: 'contatti_servizio_view',
    defaultMessage: 'Unità operativa o Uffici di riferimento',
  },
});

const ServizioContatti = ({ content }) => {
  const intl = useIntl();
  return content.ufficio_responsabile?.length > 0 || content.area.length > 0 ? (
    <RichTextArticle
      tag_id="contatti"
      title={intl.formatMessage(messages.contatti_servizio_view)}
    >
      <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
        {content.ufficio_responsabile?.length > 0 && (
          <>
            {content.ufficio_responsabile.map((item, i) => (
              <OfficeCard key={item['@id']} office={item} load_data={false} />
            ))}
          </>
        )}
        {content.area?.length > 0 && (
          <>
            {content.area.map((item, i) => (
              <OfficeCard key={item['@id']} office={item} load_data={false} />
            ))}
          </>
        )}
      </div>
    </RichTextArticle>
  ) : (
    <></>
  );
};

ServizioContatti.propTypes = {
  content: PropTypes.shape({
    // TODO: se ufficio_responsabile è requeired non serve ? in content.ufficio_responsabile?.length
    // se non è required va tolto isRequired
    ufficio_responsabile: PropTypes.array.isRequired,
    area: PropTypes.array.isRequired,
  }),
};
export default ServizioContatti;
